<template>
  <div
      class="container"
      :style="{
      background:
        'url(' +
        require('../../assets/img/' + bei_ing) +
        ') no-repeat center center',
      'background-size': '100% 100%',
    }"
  >
    <dingbu></dingbu>
    <div class="home_content">
      <div class="bg_color">
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <router-link tag="span" class="ton__zhi2" to="/learn"
              >学习系统</router-link
              >
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <div class="ton__zhi2" @click="kechengs">课程列表</div>
              <span class></span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">课程详情</span>
            </div>
          </div>
          <div class="box-mat">
            <div class="box-lok">
              <div
                  class="box-list"
                  v-for="(item, index) in addkio"
                  :key="index"
                  :data-index="index"
                  :class="orderindex == index ? 'orderactivegd' : ''"
                  @click="selorder"
              >
                <img class="ziliao" :src="item.url" alt />
                <div class="ziliao-text">{{ item.text }}</div>
              </div>
            </div>
            <div class="box-contentukj">
              <div class="ke-title">{{ addki.name }}</div>
              <div class="kecheng-listto">
                <div class="listto-ke">
                  <div class="class_hour">{{ addki.class_hour }}课时</div>
                  <div class="minrd">课程时长：{{ addki.min }}分钟</div>
                  <div class="jiezhi-time">
                    截止时间：{{ addki.expirationtime }}
                  </div>
                </div>
                <div
                    class="xuexi-jihua"
                    plain="true"
                    @click="jixue"
                    v-if="is_join == 1"
                >
                  + 加入学习计划
                </div>
                <div
                    class="xuexi-jihuaa"
                    plain="trueo"
                    @click="jixue"
                    v-if="is_join == 2"
                >
                  已加入
                </div>
              </div>
              <video-player
                  height="100%"
                  width="100%"
                  class="video-player vjs-custom-skin"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                  @pause="onplayerPause($event)"
                  @ready="playerReadied"
                  @timeupdate="onPlayerTimeupdate($event)"
                  @statechanged="playerStateChanged($event)"
                  @play="onPlayerPlay($event)"
              ></video-player>

              <div class="kecheng">课程详情</div>
              <div class="kecheng-text" v-html="addki.content"></div>
            </div>
          </div>
        </div>

        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>

    <!-- 认证失败弹窗 - 不可关闭 -->
    <div v-if="failModalVisible" class="fail-modal">
      <div class="fail-modal-content">
        <div class="fail-modal-header">
          <span class="fail-icon">⚠️</span>
          <span>认证失败</span>
        </div>
        <div class="fail-modal-body">
          <p>{{ failMessage }}</p>
          <p class="fail-tip">请重新认证或联系客服</p>
        </div>
        <div class="fail-modal-footer">
          <button @click="contactSupport" class="contact-btn">联系客服</button>
          <button @click="retryAuth" class="retry-auth-btn">重新认证</button>
        </div>
      </div>
    </div>
    <div v-if="authModalVisible" class="fail-modal">
      <div class="fail-modal-content">
        <div class="fail-modal-header">
          <span class="fail-icon">⚠️</span>
          <span>需要认证才能继续</span>
        </div>
        <div class="fail-modal-body">
          <p>{{ failMessage }}</p>
          <p class="fail-tip">请前往认证</p>
        </div>
        <div class="fail-modal-footer">
<!--          <button @click="simulateAuth" class="simulate-btn">模拟认证成功</button>-->
          <button @click="goAuth" class="retry-auth-btn">去认证</button>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- 在 index.html 中引入新版 SDK -->
<script src="https://o.alicdn.com/captcha-frontend/aliyunFP/fp.min.js"></script>
<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";

export default {
  components: {
    daohan,
    dibu,
    dingbu,
  },
  data() {
    return {
      id: "",
      muted: false,
      orderindex: 1,
      zhebi: true,
      addki: [],
      jia: false,
      fan: false,
      authCertifyId: "",
      authCertifyUrl: "",
      addkio: [
        {
          url: require("@/assets/img/jin_21.png"),
          text: "我的资料",
        },
        {
          url: require("@/assets/img/jin_20.png"),
          text: "课程列表",
        },
        {
          url: require("@/assets/img/jin_35.png"),
          text: "我的考试",
        },
        {
          url: require("@/assets/img/jin_19.png"),
          text: "考试记录",
        },
        {
          url: require("@/assets/img/jin_18.png"),
          text: "修改密码",
        }, {
          url: require("@/assets/img/jin_17.png"),
          text: "购买记录",
        }
      ],
      vio: true,
      duration: "",
      controls: false,
      coutent: "",
      gosid: "",
      orderid: "",
      miao: "",
      is_endt: "",
      is_join: '1',
      bei_ing: this.Public.bei_ing,

      // 视频标签
      playerOptions: {
        playbackRates: [1.0],
        autoplay: false,
        muted: false,
        loop: false,
        preload: 'auto',
        language: 'zh-CN',
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: "",
          src: ""
        }],
        poster: '',
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        },

      },
      isNeedAuth:false,
      defaultAuthType:'realauth',
      gklog: 0,
      duration: '',
      is_viewing: '',
      zhan_time: 0,
      zhan_switch: 0,
      stopnum: 0,
      change_view_time: 0,
      change_view_seconds: 10,

      // 认证失败弹窗相关数据
      failModalVisible: false,
      failMessage: '',
      failType: '', // 'realauth' 或 'picture'

      authModalVisible:false,
      authSysParam :null,
      authSysSetParam:null,
      // 行为监控 SDK
      learningSdk:null,
      learningProxy:null
    };
  },
  created() {
    let that = this;
    that.id = this.$route.query.id;
    that.gosid = this.$route.query.gosid;
  },
   mounted() {
      window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
     window.addEventListener('pageshow', this.onPageShow);
    this.getzan();
    this.gosid = this.$route.query.gosid;
    this.orderid = this.$route.query.orderid;
    // 先校验认证状态，通过后再加载视频
    this.setSysParam();
    setInterval(()=>{
      this.post('user/checkauth',{uid:this.$store.state.userid}).then((res)=>{
        if(res.code == 1 && res.data.needAuth){
          this.changeAuth()
          if(this.$refs.videoPlayer && this.$refs.videoPlayer.player){
            this.$refs.videoPlayer.player.pause();
          }
          this.isNeedAuth = true
          this.showAuthModal()
        }
      })
    },1000 * 60)
  },
  beforeDestroy() {
    window.removeEventListener('pageshow', this.onPageShow);
  },
  destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
    if(this.learningSdk){
      this.learningSdk.destroy();
      this.learningSdk = null;
      this.learningProxy = null;
    }
    if(this.is_viewing){
      this.change_view_status(0);
    }
    // 恢复页面滚动
    document.body.style.overflow = '';
  },
  computed: {
    playData() {
      return this.$refs.videoPlayer.player;
    },
  },
  beforeRouteLeave(to, form, next) {
    // 如果有弹窗显示，阻止离开
    if (this.failModalVisible) {
      this.$message.warning('请先处理认证失败问题');
      next(false);
      return;
    }
    next();
  },
  methods: {
    onPageShow(event) {
      // 这个判断是可选的，如果你希望无论是否从缓存来都执行，可以不加判断
      if (event.persisted) {
        // 从缓存恢复时重新校验认证状态
        this.setSysParam();
      } else {
        console.log('页面是首次正常加载的。');
      }
      // 在这里调用你希望在回退时执行的函数
    },
    changeAuth(auth = 'authing'){
      this.post('user/changeAuth',{uid:this.$store.state.userid,auth:auth})
    },
    changeAuthStatu(param){
      localStorage.setItem('authing',true)
      this.changeAuth()
      this.showAuthModal()
    },
    goAuth(){
      if(this.defaultAuthType == 'picture')
      {
        this.pictureDeal()
      }else{
        this.auth()
      }
    },
    // 模拟认证成功（开发测试用，无需摄像头）
    simulateAuth(){
      this.post('user/changeAuth',{uid:this.$store.state.userid,auth:'authsuccess'}).then(()=>{
        this.$message.success('模拟认证成功');
        this.authModalVisible = false;
        this.isNeedAuth = false;
        document.body.style.overflow = '';
        this.getvideo_detail();
      })
    },
    beforeunloadFn(e) {
      if (this.is_viewing) {
        let url = 'https://ht.tjjianan.com/api/user/change_view_status';
        let param = {
          view_status: 0,
          view_id: this.gosid,
          token: localStorage.getItem('token-qzb')
        };
        if(navigator.sendBeacon){
          this.sendBeacon(url,param)
        }else{
          this.ajaxSync(url,param);
        }
        if (this.gklog) {
          let url = "https://ht.tjjianan.com/api/user/bofang";
          let param = {
            id: this.gosid,
            duration: this.gklog,
            token: localStorage.getItem('token-qzb')
          };
          if(navigator.sendBeacon){
            this.sendBeacon(url,param)
          }else{
            this.ajaxSync(url,param);
          }
        }
      }
    },
    playerStateChanged(playerCurrentState) {
    },

    // 实人认证 - 跳转到认证页面
    auth() {
      let that = this, url = "/realauth/getCertify"
      let param = {metaInfo: window.getMetaInfo(), returnUrl: window.location.href,uid:this.$store.state.userid}
      console.log("获取到的metaInfo:", param);
      this.post(url, param).then(async res => {
        console.log(res.data.certifyUrl)
        console.log(res.data.certifyId)
        this.authCertifyId = res.data.certifyId;
        this.authCertifyUrl = res.data.certifyUrl;
        window.location.href = res.data.certifyUrl;
      }).catch(error => {
        // 请求失败显示弹窗
        this.showFailModal('获取认证信息失败，请稍后重试或联系客服。', 'realauth');
      });
    },

    // 验证实人认证结果（从地址栏参数获取）
    checkAuth() {
      const urlParams = new URLSearchParams(window.location.search);
      const responseStr = urlParams.get('response');
      if (!responseStr) {
        this.$message.warning('未找到认证结果，请先进行认证');
        this.showFailModal('未找到认证结果，请先进行认证','picture')
        return;
      }

      try {
        const responseObj = JSON.parse(decodeURIComponent(responseStr));
        const certifyId = responseObj.extInfo?.certifyId;
        this.authCertifyId = certifyId;
        this.post('/realauth/checkCertify', {certifyId: this.authCertifyId,uid:this.$store.state.userid}).then((res) => {
          if (res.code == 1 && res.data.passed == 'T') {
            // 认证成功：刷新页面清除参数（clearAuthParams 会重定向，mounted 会重新调用 setSysParam 加载视频）
            this.$message.success('认证成功');
            this.clearAuthParams()
          } else {
            // 认证失败：显示不可关闭弹窗
            this.clearAuthParams()
          }
        }).catch((error) => {
          this.showFailModal('认证服务异常，请稍后重试或联系客服。', 'realauth');
        });
      } catch (e) {
        this.showFailModal('认证结果解析失败，请重新认证。', 'realauth');
      }
    },

    // 拍照认证 - 跳转到内部拍照认证页面
    pictureDeal() {
      const urlParams = new URLSearchParams(window.location.search);
      let query = { page: 'study', uid: this.$store.state.userid }
      for (const [key, value] of urlParams) {
        if (!query.hasOwnProperty(key)) {
          query[key] = value
        }
      }
      this.$router.push({ path: '/authCamera', query: query });
    },

    // 清除URL中的认证相关参数
    clearAuthParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const paramsToRemove = ['response', 'picture'];
      paramsToRemove.forEach(param => {
        urlParams.delete(param);
      });

      const newUrl = window.location.href.split('?')[0] + (urlParams.toString() ? '?' + urlParams.toString() : '');
      if (newUrl !== window.location.href) {
      //   window.history.replaceState({}, '', newUrl);
        setTimeout(()=>{
          window.location.href = newUrl
        },1000)

      }
    },

    // 显示不可关闭的失败弹窗
    showFailModal(message, type = 'realauth') {
      this.failMessage = message;
      this.failType = type;
      this.failModalVisible = true;
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';

    },
    showAuthModal() {
      this.authModalVisible = true;
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';
    },

    // 关闭失败弹窗（内部使用）
    hideFailModal() {
      this.failModalVisible = false;
      this.failMessage = '';
      this.failType = '';
      // 恢复页面滚动
      document.body.style.overflow = '';
    },

    // 联系客服
    contactSupport() {
      this.isNeedAuth = false
      this.failModalVisible = false
    },

    // 重新认证
    retryAuth() {

      // 关闭弹窗
      this.hideFailModal();
      // 根据之前的认证类型，重新发起对应认证
      if (this.defaultAuthType != 'picture') {
        this.auth();
      } else {
        this.pictureDeal();
      }
    },

    onPlayerPlay(player) {
      this.change_view_status(1);
      this.is_viewing = 1;
      document.querySelector(".vjs-progress-control").style.pointerEvents = "none";
    },
    onPlayerTimeupdate(player) {
      this.gklog = player.cache_.currentTime;
      if (this.zhan_switch == 1) {
        if (player.cache_.currentTime > this.zhan_time) {
          this.playData.pause();
          this.change_view_status(0);
          this.zhan_time += this.stopnum;
        }
      }
      if(player.cache_.currentTime >= this.change_view_time){
        this.change_view_status(1);
        this.change_view_time += this.change_view_seconds;
      }
    },
    onplayerPause(player) {
      this.change_view_status(0);
      this.duration = player.cache_.currentTime
      this.Recordtheplay()
    },
    playerReadied(player) {
      player.currentTime(this.gklog)
    },
    ji() {
      this.jia = false;
      this.fan = true;
    },
    xuea() {
      this.fan = false;
      sessionStorage.setItem("videoxian", 2);
      document.body.style.overflow = "";
      document.removeEventListener("touchmove", { passive: false });
    },
    getPath() {
    },
    kechengs() {
      if (sessionStorage.getItem("kai")) {
      } else {
        sessionStorage.setItem("kai", 1);
      }
      this.$router.push("/profile?id=" + this.id + '&orderindex=1');
    },
    selorder(e) {
      this.orderindex = e.currentTarget.dataset.index;

      localStorage.setItem("ordertodo", this.orderindex);
      if (this.orderindex == 0) {
        this.$router.push({ path: "/profile", query: { id: this.id } });
      }
      if (this.orderindex == 2) {
        this.$router.push({ path: "/profile", query: { id: this.id } });
      }
      if (this.orderindex == 3) {
        this.$router.push({ path: "/profile", query: { id: this.id } });
      }
      if (this.orderindex == 4) {
        this.$router.push({ path: "/profile", query: { id: this.id } });
        document.getElementById("app").scrollIntoView();
        var mo = function (e) {
          e.preventDefault();
        };
        document.body.style.overflow = "hidden";
        document.addEventListener("touchmove", mo, false);
      }
      if (this.orderindex == 5) {
        this.$router.push({ path: "/profile", query: { id: this.gosid } });
        document.documentElement.scrollTop = 200;
        document.getElementById("app").scrollIntoView();
        var mo = function (e) {
          e.preventDefault();
        };
        document.body.style.overflow = "hidden";
        document.addEventListener("touchmove", mo, false);
      }
    },
    Recordtheplay() {
      let that = this, url = "user/bofang", param = {
        id: that.gosid,
        duration: that.duration,
      };
      this.post(url, param)
          .then((res) => {
          })
          .catch((err) => {
          });
    },
    jixue() {
      let that = this, url = "user/join", param = {
        id: that.gosid,
        duration: that.duration,
      };
      this.post(url, param)
          .then((res) => {
            that.is_join = 2
            that.$message(res.msg);
            localStorage.setItem("id", id);
          })
          .catch((err) => {
          });
    },
    change_view_status(e) {
      let that = this;
      let url = "user/change_view_status";
      let param = {
        view_status: e,
        view_id: that.gosid,
      };
      that.post(url, param).then((res) => {});
    },
    setSysParam(){
      let url = 'user/authInfo'
      let sysParam = null
      let authParam = null
      this.post(url,{uid:this.$store.state.userid}).then((res)=>{
          if(res.code == 1){
            sysParam= res.data.authset
            authParam= res.data.auth
            this.authSysSetParam = sysParam
            this.authSysParam = authParam
            if(sysParam.real_switch == 1){
              //需要实人认证
              this.defaultAuthType = 'realauth'
            }else{
              this.defaultAuthType = 'picture'
            }

            if(this.authSysParam.bio == 'authsuccess')
            {
              // 已认证，加载视频
              this.clearAuthParams()
              this.isNeedAuth = false
              this.getvideo_detail()
            }
            else if(this.authSysParam.bio == 'authing' && this.defaultAuthType == 'realauth')
            {
              this.checkAuth()
            }
            else if(this.authSysParam.bio == 'authfail')
            {
              this.isNeedAuth = true
              this.showFailModal("认证失败，请重新认证",this.defaultAuthType)
            }
            else{
              // 未认证（bio为空或其他），弹出认证弹窗
              this.isNeedAuth = true
              this.showAuthModal()
            }
          }
      })

    },
    getvideo_detail() {
      let that = this;
      var url = "user/video_detail";
      let param = {
        id: this.gosid,
      };
      that.post(url, param)
          .then((res) => {
//            this.setSysParam()
            that.addki = res.data;
            this.playerOptions['sources'][0]['src'] = res.data.video_file
            this.playerOptions['poster'] = res.data.video_image
            this.gklog = res.data.bofangtime
            that.is_endt = res.data.is_end;
            that.is_join = res.data.is_join
            if (that.addki.is_end == 1) {
              that.controls = true;
              that.coutent = 0;
            } else {
              that.coutent = that.addki.bofangtime;
            }

            that.zhan_switch = res.data.auto_pause.switch;
            if (that.zhan_switch == 1) {
              that.zhan_time = that.coutent+ (res.data.auto_pause.stopnum * 60);
              that.stopnum = res.data.auto_pause.stopnum *60;
            }
            that.change_view_time = that.coutent + that.change_view_seconds
            // 创建行为监控 SDK（学习模式）绑定视频
            console.log(window.SafetyAuditSDK)
            console.log(res.data.session_token)
            if(res.data.session_token && window.SafetyAuditSDK){
              this.initLearningSdk(res.data.session_token)
            }
          })
          .catch((err) => {
          });
    },
    // 创建行为监控 SDK（学习模式）并通过 proxy 绑定视频播放行为
    initLearningSdk(session_token) {
      if (this.learningSdk) {
        this.learningSdk.destroy();
        this.learningSdk = null;
        this.learningProxy = null;
      }
      this.learningSdk = new window.SafetyAuditSDK({
        token: session_token,
        mode: 'learning',
        baseURL: 'https://www.agryjxjy.cn',
        debug: false,
      });
      console.log("learning")
      console.log(this.learningSdk)
      // 方式二：第三方播放器（video.js）手动触发回调
      this.learningProxy = this.learningSdk.bindVideoProxy();
      console.log(this.learningProxy)
      this.bindVideoToSdk();
    },
    // 为 video.js 播放器绑定播放行为回调
    bindVideoToSdk() {
      let player = this.$refs.videoPlayer && this.$refs.videoPlayer.player;
      if (!player || !this.learningProxy) {
        // 播放器尚未就绪，稍后重试
        setTimeout(() => this.bindVideoToSdk(), 1000);
        return;
      }
      // 播放 / 暂停 / 进度更新 / 倍速 / 快进 / 结束
      player.off('play', this.sdkOnPlay);
      player.off('pause', this.sdkOnPause);
      player.off('timeupdate', this.sdkOnTimeUpdate);
      player.off('ratechange', this.sdkOnRateChange);
      player.off('seeking', this.sdkOnSeeking);
      player.off('ended', this.sdkOnEnded);
      player.on('play', this.sdkOnPlay);
      player.on('pause', this.sdkOnPause);
      player.on('timeupdate', this.sdkOnTimeUpdate);
      player.on('ratechange', this.sdkOnRateChange);
      player.on('seeking', this.sdkOnSeeking);
      player.on('ended', this.sdkOnEnded);
    },
    sdkOnPlay() {
      if (this.learningProxy) this.learningProxy.onPlay(this.curTime());
    },
    sdkOnPause() {
      if (this.learningProxy) this.learningProxy.onPause(this.curTime());
    },
    sdkOnTimeUpdate() {
      if (this.learningProxy) this.learningProxy.onTimeUpdate(this.curTime());
    },
    sdkOnRateChange() {
      let player = this.$refs.videoPlayer && this.$refs.videoPlayer.player;
      if (this.learningProxy && player) this.learningProxy.onRateChange(player.playbackRate());
    },
    sdkOnSeeking() {
      if (this.learningProxy) this.learningProxy.onSeeked(this.curTime());
    },
    sdkOnEnded() {
      if (this.learningProxy) this.learningProxy.onEnded();
    },
    curTime() {
      let player = this.$refs.videoPlayer && this.$refs.videoPlayer.player;
      return player ? player.currentTime() : 0;
    },
    getzan() {
      let that = this;
      var url = "index/zan";
      let param = {};
      this.post(url)
          .then((res) => {
            this.miao = res.data.stopnum;
          })
          .catch((err) => {
          });
    },
    sendBeacon(url,param){
      let data = new FormData();
      for (let key in param) {
        data.append(key, param[key]);
      }
      let result = navigator.sendBeacon(url, data);
    },
    ajaxSync(url,param) {
      var client = new XMLHttpRequest();
      client.open("POST", url, false);
      client.setRequestHeader("Content-Type", "application/json; charset=utf-8");
      client.send(JSON.stringify(param));
    },
  },
};
</script>

<style scoped>
@import "../../css/train.css";

/* ========== 不可关闭失败弹窗样式 ========== */
.fail-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  pointer-events: auto;
}

.fail-modal-content {
  width: 85%;
  max-width: 340px;
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.2s ease-out;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.fail-modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 16px 8px;
  font-size: 18px;
  font-weight: bold;
  color: #ff4d4f;
}

.fail-icon {
  font-size: 24px;
}

.fail-modal-body {
  padding: 16px 20px;
  text-align: center;
  color: #333;
  line-height: 1.5;
}

.fail-tip {
  margin-top: 12px;
  font-size: 12px;
  color: #999;
}

.fail-modal-footer {
  padding: 16px 20px 24px;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.contact-btn,
.retry-auth-btn {
  border: none;
  border-radius: 30px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  flex: 1;
  max-width: 130px;
}

.contact-btn {
  background-color: #f0f0f0;
  color: #666;
}

.contact-btn:hover {
  background-color: #e0e0e0;
}

.retry-auth-btn {
  background-color: #1890ff;
  color: white;
}

.retry-auth-btn:hover {
  background-color: #40a9ff;
}
.simulate-btn {
  background-color: #52c41a;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  flex: 1;
  max-width: 130px;
}
.simulate-btn:hover {
  background-color: #73d13d;
}
</style>
